
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AdvantagesSection() {
  const { t } = useTranslation();

  const advantages = [
    {
      icon: 'ri-shield-check-line',
      title: t('home.bankSec'),
      description: t('features.security.desc'),
      stats: '256-bit SSL'
    },
    {
      icon: 'ri-speed-line',
      title: t('platform.ufe'),
      description: t('contact.lightFast'),
      stats: t("platform.executionSpeedStat", { defaultValue: "0.01s Speed" })
    },
    {
      icon: 'ri-customer-service-line',
      title: t('home.247s'),
      description: t('platform.rtc'),
      stats: t('platform.247a')
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title:  t('platform.csp'),
      description: t('platform.iia'),
      stats: t('platform.01pip')
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            {t('platform.wco')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('platform.etd')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="text-center group hover:transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className="bg-gradient-to-br from-amber-500 to-amber-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${advantage.icon} text-3xl text-white`}></i>
              </div>
              <div className="bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-4 inline-block">
                {advantage.stats}
              </div>
              <h3 className="text-xl font-bold mb-4">
                {advantage.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Additional Info */}
        <div className="mt-16 bg-gradient-to-r from-amber-600 to-amber-500 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">
             {t('platform.rts')}
          </h3>
          <p className="text-lg mb-6 opacity-90">
             {t('platform.jto')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="https://portal.jlbhk.com/regist-real?invitid=H551M0-QSRWL57867r"><button className="bg-white text-amber-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap">
              <i className="ri-user-add-line mr-2"></i>
               {t('platform.ola')}
            </button></Link>
             <Link to="https://portal.jlbhk.com/regist-real?invitid=H551M0-QSRWL57867"><button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-amber-600 transition-colors whitespace-nowrap">
              <i className="ri-play-line mr-2"></i>
               {t('platform.tda')}
            </button></Link>
          </div>
        </div>
      </div>
    </section>
  );
}
